export const USED_SUBSCRIPTION_TICKET = 'used-subscription-ticket'
